import Europe40under40AwardFrame from "./components/Europe40under40AwardFrame";
import Europe40under40AwardForm from "./components/Europe40under40AwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/europe40under40-design-award",
        name: "europe40under40-design-award",
        redirect: "/europe40under40-design-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "europe40under40",
            awardName: "Europe 40 under 40 Design Award",
        },
        component: Europe40under40AwardFrame,
        children: [
            {
                path: "",
                component: Europe40under40AwardForm,
                name: "europe40under40-design-award-form",
            },
            ...UserAccountRoutes,
        ],
    },

    /*/future-house-awards*/
];
